import { render } from "./TemplateKpiCard.vue?vue&type=template&id=6540342a"
import script from "./TemplateKpiCard.vue?vue&type=script&lang=js"
export * from "./TemplateKpiCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__